"use client"

import { Font } from "components/shopFeatures/wizard/constants"
import styled from "styled-components"

const StyledPreSaleTag = styled.span<{ $size: "small" | "medium" | "large" }>`
  padding: ${(p) =>
    p.$size === "small"
      ? "4px 8px"
      : p.$size === "medium"
      ? "4px 8px"
      : "4px 16px"};
  text-transform: uppercase;
  color: ${(p) => p.theme.colors.white};
  background-color: ${(p) => p.theme.colors.mazdaRed};
  border-radius: 4px;
  text-align: center;
  font-family: ${Font.OENaPro};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 130%; /* 18.2px */
  height: 26px;
  width: ${(p) =>
    p.$size === "small" ? "74px" : p.$size === "medium" ? "74px" : "90px"};
  display: block;
`

const PreSaleTag = ({ size }: { size: "small" | "medium" | "large" }) => {
  return <StyledPreSaleTag $size={size}>Pre-Sale</StyledPreSaleTag>
}

export default PreSaleTag
